import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { isPresent } from '@mtna/core-ts';

@Pipe({
  name: 'rdsFirstItem',
})
export class RdsFirstItemInArrayPipe implements PipeTransform {
  transform<T>(array: T[] | undefined | null): T | null {
    if (!isPresent(array)) {
      return null;
    }

    return isPresent(array[0]) ? array[0] : null;
  }
}

@NgModule({
  exports: [RdsFirstItemInArrayPipe],
  declarations: [RdsFirstItemInArrayPipe],
})
export class RdsFirstItemInArrayPipeModule {}
